export const REDIRECT_URL = __ANYDO_ENV_DEV__ ? "https://develop.anydo.dev/myday" : "https://app.any.do/myday";

export const GOOGLE_CLIENT_ID = __ANYDO_ENV_DEV__
  ? "543675644531-u3crpgh3nks32rhtqbolhmrlj8uvcir6.apps.googleusercontent.com"
  : "543675644531-nsdamnj2uqafj8d3hv9q9lmevvc9tcrm.apps.googleusercontent.com";

export const GOOGLE_RECAPTCHA_SITE_KEY = __ANYDO_ENV_DEV__
  ? "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
  : "6LcGquEpAAAAAD4IylxfEVMjTOm8EqTnCkl9pCc9";

export const BASE_URL = __ANYDO_ENV_DEV__
  ? "https://sm-dev-teams.any.do"
  : "https://sm-prod4.any.do";

export const CHECK_EMAIL_URL = `${BASE_URL}/check_email`;
export const USER_URL = `${BASE_URL}/user`;
export const PRE_2FA_LOGIN_URL = `${BASE_URL}/login-2fa`;
export const LOGIN_2FA_URL = `${BASE_URL}/login-2fa-code`;
export const GOOGLE_LOGIN_URL = `${BASE_URL}/google-login`;

export const BOARD_TEMPLATE_DATA_KEY = "onboarding_templates/en__other__project.json";

export const SHOW_TRIAL_PLAN = typeof location !== 'undefined' ? new URLSearchParams(location.search).has("trial") : false;
